import React, { useLayoutEffect } from "react";
import { ReactComponent as CloseIcon } from "common/assets/icons/x.svg";
import { ReactComponent as LogoutIcon } from "common/assets/icons/log-out.svg";
import { Htag } from "common/Htag/Htag";
import { Button } from "common/Button/Button";
import { motion } from "framer-motion";
import { LogoutModalProps } from "./LogoutModal.props";
import { P } from "common/P/P";

const LogoutModal: React.FC<LogoutModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	onCancel,
	width,
	icon,
	scroll,
}) => {
	useLayoutEffect(() => {
		if (isOpen) {
			document.body.style.overflow = "hidden";
		}
		return () => {
			document.body.style.removeProperty("overflow");
		};
	}, [isOpen]);

	const LogoutModalVariants = {
		open: { opacity: 1, transition: { duration: 0.3 } },
		closed: { opacity: 0, transition: { duration: 0.3 } },
	};

	return (
		<>
			<div
				className={`${scroll && "overflow-auto"} ${
					isOpen ? "fixed inset-0 z-50" : "hidden"
				} backdrop-blur-sm bg-[rgba(47,47,47,0.65)]`}
				onClick={onClose}
			></div>
			{isOpen && (
				<motion.div
					initial="closed"
					animate="open"
					exit="closed"
					variants={LogoutModalVariants}
					className={`fixed top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 ${
						width ? width : "w-[600px]"
					} bg-[#f5f5f5] flex flex-col z-50 rounded-lg shadow-lg`}
				>
					<div className="flex items-center p-4 bg-[#f5f5f5] rounded-t-lg place-self-end ">
						<CloseIcon onClick={onClose} className="cursor-pointer" />
					</div>
					<div className="grid gap-4">
						<div className="rounded-full bg-redBgColor p-[10px] w-max place-self-center">
							<LogoutIcon className="stroke-redColor" />
						</div>
						<div className="grid flex-grow gap-8 px-16 pb-8 overflow-y-auto place-content-center place-items-center">
							<Htag
								tag="h1"
								type="medium"
								className="text-center cursor-default text-textColor"
							>
								Hakykatdan hem ulgamdan çykmak isleýärsiňizmi?
							</Htag>
						</div>
						<div className="grid gap-4 pb-12 grid-cols-maxTwo place-content-center place-items-center">
							<Button appearance="ghost" onClick={onCancel}>
								Yza gaýtmak
							</Button>
							<Button appearance="red" onClick={onConfirm}>
								Ulgamdan çykmak
							</Button>
						</div>
					</div>
				</motion.div>
			)}
		</>
	);
};

export default LogoutModal;
